import React from "react";
import { Widget } from "@typeform/embed-react";
export function FormSection({ section }) {
  return (
    <>
      <section className="container-fluid eva-text-center container-blocks" >
        <Widget
          id="GOKEueDQ"
          height={600}
        />
      </section >
    </>
  )
}